import type { StatusAssessment } from "../domain/stats.js";
import { formatDateTime, laterOf } from "../domain/dates.js";

/** 分享頁的數值列表。 */
export function ShareMetrics({ metrics }: { metrics: [label: string, value: string][] }) {
  return (
    <>
      {metrics.map(([label, value]) => (
        <div class="share-metric"><span>{label}</span><strong>{value}</strong></div>
      ))}
    </>
  );
}

/** 達標率長條。null 代表資料不足，長條歸零但文字顯示破折號。 */
export function ShareCompliance({ rows }: { rows: [label: string, value: number | null][] }) {
  return (
    <>
      {rows.map(([label, value]) => (
        <div class="progress-row">
          <span>{label}</span>
          <div class="progress-track">
            <div class="progress-fill" style={{ width: `${value || 0}%` }} />
          </div>
          <b>{value === null ? "—" : `${Math.round(value)}%`}</b>
        </div>
      ))}
    </>
  );
}

export function ShareAdvice({ assessment }: { assessment: StatusAssessment }) {
  return (
    <>
      <b>{assessment.label}</b>
      <br />
      {assessment.advice}
    </>
  );
}

export interface SyncStatusData {
  measurementCount: number;
  lastMeasuredAt: string | null;
  lastBodySyncAt: string | null;
  lastHealthSyncAt: string | null;
  healthDayCount: number;
  lastStepsDate: string | null;
  timezone: string;
}

/** 設定頁的同步狀態。取不到資料時只顯示錯誤訊息。 */
export function SyncStatus({ status, error }: { status?: SyncStatusData; error?: string }) {
  if (error || !status) {
    return <><dt>狀態</dt><dd>{error}</dd></>;
  }
  return (
    <>
      <dt>資料庫</dt><dd>正常</dd>
      <dt>InBody 測量筆數</dt><dd>{status.measurementCount}</dd>
      {/*
        兩件不同的事，先前混成一項叫「最後 InBody 同步」但顯示的是量測時間：
        量測時間是站上 InBody 那一刻，同步時間是捷徑把資料送進來那一刻。
        按了捷徑會動的是後者——前者要等你下次量體重才會變。
      */}
      <dt>最後量測</dt><dd>{formatDateTime(status.lastMeasuredAt)}</dd>
      <dt>最後同步</dt>
      <dd>{formatDateTime(laterOf(status.lastBodySyncAt, status.lastHealthSyncAt))}</dd>
      <dt>健康資料日數</dt><dd>{status.healthDayCount || 0}</dd>
      <dt>最新步數日期</dt><dd>{status.lastStepsDate || "尚未同步"}</dd>
      <dt>時區</dt><dd>{status.timezone}</dd>
    </>
  );
}

export interface EnergyPreviewProps {
  source: string;
  weight: string;
  bmr: string;
  tdee: string;
}

export function EnergyPreview({ source, weight, bmr, tdee }: EnergyPreviewProps) {
  return (
    <>
      目前以 <b>{source} {weight} kg</b> 計算：BMR 約 <b>{bmr} kcal</b>；今天 TDEE 約 <b>{tdee} kcal</b>。
    </>
  );
}
